<template>
    <!-- Toggles read better as a single row with the control trailing the label;
         every other control stacks its label above a full-width input. -->
    <div    v-if="inline"
            class="flex items-start justify-between gap-4 py-3">
        <div class="flex-1">
            <label  :for="fieldId"
                    class="m-0 block text-left text-sm font-medium text-gray-700">
                {{ label }}
            </label>
            <p  v-if="description"
                class="m-0 mt-0.5 text-left text-sm text-gray-500">
                {{ description }}
            </p>
        </div>

        <div class="shrink-0 pt-0.5">
            <slot></slot>
        </div>

        <p  v-if="error"
            class="m-0 mt-1 text-xs text-red-500">
            {{ error }}
        </p>
    </div>

    <!-- No vertical padding when there is no label: a repeater passes an empty
         label for its rows, and the padding otherwise left a gap above every
         row that the row itself did not account for. -->
    <div    v-else
            :class="label ? (compact ? 'py-2' : 'py-3') : ''">
        <!-- Compact (a bare section, e.g. Report Details): the designs' bold
             label, with the description behind an info tip. -->
        <div    v-if="label && compact"
                class="mb-1 flex items-center gap-2">
            <label  :for="fieldId"
                    class="m-0 block text-left text-sm font-semibold text-gray-900">
                {{ label }}
            </label>
            <info-tip   v-if="description"
                        :text="description"
            ></info-tip>
        </div>

        <label  v-else-if="label"
                :for="fieldId"
                class="mb-2 block text-left text-sm font-medium text-gray-700">
            {{ label }}
        </label>

        <slot></slot>

        <p  v-if="description && ! compact"
            class="m-0 mt-1 text-left text-sm text-gray-500">
            {{ description }}
        </p>

        <p  v-if="error"
            class="m-0 mt-1 text-left text-xs text-red-500">
            {{ error }}
        </p>
    </div>
</template>

<script>
import InfoTip from "@/components/elements/InfoTip.vue"

export default {
    name: "ReportFieldRow",
    components: {InfoTip},
    // Set by a bare ReportSettingsSection.
    inject: {
        compact: {from: 'reportFieldRowCompact', default: false},
    },
    props: {
        fieldId: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: null,
        },
        error: {
            type: String,
            default: null,
        },
        // Place the control beside the label rather than beneath it.
        inline: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
